import { extensionBoatmasterOptions, ICertificate } from "../../../models/certificate";
import { formatDateForCertificateView } from "../../../models/common";
import { IIDDataSet } from "../../../models/crewMember";
import stamp from "../../../images/SRH_stamp.png";
import { ucqRiverRangeProps } from "../../../models/riverRanges";

type Props = {
    certificate: ICertificate;
    idDataSet: IIDDataSet;
    imageBase64: string;
    qrBase64: string;
};

export const ExtensionBoatmasterOnTheRhineView = ({
    certificate,
    idDataSet,
    imageBase64,
    qrBase64,
}: Props) => {
    const getAllStretches = (certificate: ICertificate) => {
        let allStretches = certificate.stretchesRiverKilometers.map(stretch => {
            return ucqRiverRangeProps.find(range => range.key === stretch)?.text?.toString();
        });
        const manuelStretches = certificate.stretchesManualRiverKilometers.split(";");
        allStretches = allStretches.concat(manuelStretches);

        return allStretches.map((stretch, index) => {
            return (
                <span key={index}>
                    {stretch}
                    <br />
                </span>
            );
        });
    };

    return (
        <div id="extension-view">
            <div className="title">Vorläufiges Rheinpatent</div>
            <div className="entry-block">
                <h4>Schweizerische Eidgenossenschaft</h4>
                <span>Ausstellende Behörde:</span>
                <span>Schweizerische Rheinhäfen</span>
                <p></p>
                <div>
                    <span>{`Befähigungszeugnis für die Binnenschifffahrt Schiffsführer - ${
                        extensionBoatmasterOptions.find(
                            x => x.value === certificate.extensionBoatmasterType
                        )?.content as string
                    }`}</span>
                </div>
                <div className="entry">
                    <span>Befähigungs-ID: </span>
                    <span>{certificate.qualificationID}</span>
                </div>
                <p></p>
            </div>
            <div className="entry-image-block">
                <div className="entry-block">
                    <h4>Personendaten</h4>
                    <div className="entry">
                        <span>Besatzungsmitgliedernummer (CID): </span>
                        <span>{idDataSet.cid}</span>
                    </div>
                    <div className="entry">
                        <span>Nachname: </span>
                        <span>
                            {!!idDataSet.nonLatinLastName
                                ? idDataSet.nonLatinLastName
                                : idDataSet.lastName}
                        </span>
                    </div>
                    <div className="entry">
                        <span>Vorname: </span>
                        <span>
                            {!!idDataSet.nonLatinFirstName
                                ? idDataSet.nonLatinFirstName
                                : idDataSet.firstName}
                        </span>
                    </div>
                    <div className="entry">
                        <span>Geburtsdatum: </span>
                        <span>{formatDateForCertificateView(idDataSet.dateOfBirth)}</span>
                    </div>
                    <div className="entry">
                        <span>Geburtsort: </span>
                        <span>{idDataSet.placeOfBirth}</span>
                    </div>
                </div>
                <img
                    src={`data:image/jpg;base64,${imageBase64}`}
                    alt="User image"
                    style={{ width: "78px", height: "98px" }}
                />
            </div>
            <div className="entry-image-block">
                <div className="text-block">
                    <span>
                        Streckenabschnitte des Rheins:
                        <br />
                        <br />
                        {getAllStretches(certificate)}
                    </span>
                </div>
                <img
                    src={`data:image/jpg;base64,${qrBase64}`}
                    alt="QR"
                    style={{ width: "200px", height: "200px" }}
                />
            </div>
            <div className="text-block">
                <span>
                    Basierend auf Befähigungszeugnis für die Binnenschifffahrt Schiffsführer Nr.
                    <br />
                    {certificate.linkedCertificateQualificationID}
                </span>
            </div>
            <p></p>
            <div className="text-block">
                <span>
                    Dieses vorläufige Dokument läuft zwölf Monate nach dem Ausstellungsdatum ab und
                    ist nur gültig im Zusammenhang mit einem Personalausweis oder Reisepass.
                </span>
            </div>
            <div className="date-block">
                <span>Basel, {formatDateForCertificateView(new Date().toDateString())}</span>
            </div>
            <div className="stamp-block">
                <img src={stamp} alt="Stamp image" style={{ width: "100px", height: "100px" }} />
                <span>(Unterschrift der ausstellenden Behörde)</span>
            </div>
        </div>
    );
};
